export default "__VITE_ASSET__DYpHNGsI__"